import { InputSkeleton, TextareaSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <TextareaSkeleton className="col-span-12" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
        <RightSection>
          <CardContainer right>
            <SectionHeadingSkeleton withRightSlot />
            <PhoneNumberLoading />
          </CardContainer>
        </RightSection>
      </Container>
    </>
  );
}
